

import React, { memo } from 'react';
import { Button, Text } from '../../../../../../ui-kit';







function AddNewItem({ addNewItem, disabled, label }) {
  return (
    <Button className="new-item" disabled={disabled} type="TERTIARY" prefix="addfat" onClick={addNewItem}>
      <Text heading5>{label || ''}</Text>
    </Button>);

}

export default memo(AddNewItem);